import { Children, type ReactNode } from 'react';

import { applyThresholdDefaults } from './apply-threshold-default.js';
import { Intent, type IntentProps } from '../../../core/slots/Intent/Intent.js';
import { isSlot } from '../../../core/utils/is-slot.js';
import { ColorRule, isValidColorRule } from '../../core/slots/ColorRule.js';
import { Label } from '../slots/Label.js';
import { ThresholdIndicator } from '../slots/ThresholdIndicator.js';
import { GaugeChartToolbarSlot } from '../slots/Toolbar.js';
import { Tooltip } from '../slots/Tooltip.js';
import type { GaugeChartSlotsConfig } from '../types/gauge-chart-config.js';

export const iterateSlots = (children?: ReactNode): GaugeChartSlotsConfig => {
  const slots: GaugeChartSlotsConfig = {
    thresholdsIndicators: [],
    colorRules: [],
    toolbar: {},
    intents: [],
  };
  const intents: IntentProps[] = [];

  Children.forEach(children, (child) => {
    if (isSlot(child, Label)) {
      slots.label = child.props.children ?? null;
    } else if (isSlot(child, ThresholdIndicator)) {
      const threshold = applyThresholdDefaults(child.props);
      slots.thresholdsIndicators.push(threshold);
    } else if (isSlot(child, ColorRule)) {
      const colorRule = child.props;
      if (isValidColorRule(colorRule)) {
        slots.colorRules.push(colorRule);
      }
    } else if (isSlot(child, Intent)) {
      intents.push(child.props);
    } else if (isSlot(child, GaugeChartToolbarSlot)) {
      slots.toolbar = child.props;
    } else if (isSlot(child, Tooltip)) {
      slots.tooltip = child.props;
    }
  });

  if (!intents.length) {
    slots.toolbar = { ...slots.toolbar, hidden: true };
  } else {
    slots.intents = intents;
  }

  return slots;
};
